import { getPlanKey } from "@/hooks/use-is-selected-plan";
import { ItineraryCard } from "../itinerary-card";
import { AppItineraryOrNode } from "@/types/otp/+extended";
import { ItineraryCardNoRoutes } from "../states/itinerary.no-routes";

export function ItineraryListContent({
    itineraries
}: {
    itineraries?: AppItineraryOrNode[] | null
}) {
    if (!itineraries || itineraries.length <= 0) {
        return <ItineraryCardNoRoutes />
    }

    return (
        <div className="flex flex-col gap-4">
            {itineraries.map((i) => {
                return (
                    <ItineraryCard
                        key={getPlanKey(i)}
                        {...i}
                    />
                )
            })}
        </div>
    )
}
